import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M4.197 0A2.217 2.217 0 002 2.201V13.8c0 1.199.995 2.2 2.197 2.2h7.607A2.215 2.215 0 0014 13.799V2.2c0-1.199-.994-2.2-2.196-2.2zm0 2h7.607c.124 0 .196.07.196.201V13.8c0 .13-.072.201-.196.201H4.197C4.073 14 4 13.93 4 13.799V2.2c0-.13.073-.201.197-.201z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#bebebe" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M8.78 5a1.023 1.023 0 00-.47.281l-3.03 3a1.018 1.018 0 00-.282.906V10h2.47l-1.187 1.274c-.214.219-.32.54-.28.843a1.464 1.464 0 000 .094v.781H7a1.03 1.03 0 00.719-.281l3-2.992c.184-.19.287-.455.281-.719a.87.87 0 000-.125V8H8.436l1.312-1.281c.215-.22.322-.54.281-.844a1.464 1.464 0 000-.094V5H9.03a1.015 1.015 0 00-.25 0z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "'Bitstream Vera Sans'",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} color="#bebebe" fontWeight={400} fontSize="xx-small" fontFamily="Bitstream Vera Sans" overflow="visible" /><path d="M5 3h1v1H5zm2 0h4v1H7z" style={{
        marker: "none"
      }} color="#000" overflow="visible" /></g></svg>;
}

export default SvgComponent;